import { useEffect, useRef } from 'react';

interface Props {
  x: number;
  y: number;
  onClose: () => void;
  onNewFolder: () => void;
  onUpload: () => void;
}

export default function BackgroundContextMenu({ x, y, onClose, onNewFolder, onUpload }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  // Adjust position to stay in viewport
  const adjustedX = Math.min(x, window.innerWidth - 200);
  const adjustedY = Math.min(y, window.innerHeight - 150);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    const escHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', escHandler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', escHandler);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="dropdown-menu show feebbo-dropdown shadow"
      style={{ position: 'fixed', top: adjustedY, left: adjustedX, minWidth: 180, zIndex: 1055 }}
    >
      <button
        className="dropdown-item d-flex align-items-center gap-2"
        onClick={() => {
          onUpload();
          onClose();
        }}
      >
        <i className="bi bi-cloud-upload" />
        Subir archivos
      </button>
      <div className="dropdown-divider" />
      <button
        className="dropdown-item d-flex align-items-center gap-2"
        onClick={() => {
          onNewFolder();
          onClose();
        }}
      >
        <i className="bi bi-folder-plus" />
        Nueva carpeta
      </button>
    </div>
  );
}
